import React, { useContext, useEffect, useState } from 'react'
import useFetch from '../hooks/useFetch'
import { getPeriod } from '../helpers/helpers'
import { DataContext } from '../contexts/DataProvider'
import { Contract } from '../utils/models'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
export default function ContractList({ contracts, selectedContract }) {
  const { setActiveContract, startDate, endDate, period, setError } = useContext(DataContext)
  const [contractData, setContractData] = useState(contracts[0].id)

  const [isLoadingContract, dataContract, errorContract] = useFetch('getStudie', {}, [contractData], {
    studieId: contractData,
    startTime: startDate.format('MM.DD.YYYY'),
    endTime: endDate.format('MM.DD.YYYY'),
    period: getPeriod(period),
  })

  useEffect(() => {
    const contractFromNotification = contracts.find((contract) => contract.id === selectedContract)

    if (contracts) {
      if (contractFromNotification) {
        console.log(contractFromNotification)

        setContractData(contractFromNotification.id)
      }
    }
  }, [selectedContract])

  useEffect(() => {
    if (errorContract) {
      setError({ isError: true, errorMessage: 'Error during fetching contract' })
    }
    if (!dataContract) {
      return
    }
    setActiveContract(dataContract?.results)
  }, [dataContract, errorContract])

  const handleSelect = (e) => {
    setContractData(e.target.value)
  }

  return (
    <div>
      <FormControl fullWidth>
        <InputLabel id="select-contract-label">Select contract</InputLabel>
        <Select
          labelId="select-contract-label"
          id="select-contract"
          value={contractData as string}
          label="Select contract"
          onChange={handleSelect}
        >
          {contracts.map(({ id, name }: Contract) => {
            return (
              <MenuItem key={id} value={id}>
                {name}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    </div>
  )
}
